module.exports = __webpack_public_path__ + "img/kss_logo.a7e5fcba.png";